import { TablePaginationConfig } from 'antd';
import PageSizeSelect from 'components/ui/composed/selects/PageSizeSelect';
import { ALL_ITEMS_PAGE_SIZE } from 'core/http/pagination';
import { ListPayload } from 'core/http/response';

const PAGE_SIZES = [10, 20, 50, ALL_ITEMS_PAGE_SIZE];

const getProductsTablePagination = (data?: ListPayload<unknown> | null): TablePaginationConfig => {
    const fitsOnOnePage = data != null && data.total <= data.pageSize;

    return {
        current: (data?.pageNumber || 0) + 1,
        total: data?.total,
        pageSize: data?.pageSize,
        position: ['bottomCenter'],
        className: fitsOnOnePage ? 'pagination-single-page' : undefined,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZES.map(String),
        hideOnSinglePage: data?.pageSize === ALL_ITEMS_PAGE_SIZE ? false : true,
        // Not in antd's TablePaginationConfig type, but antd's Pagination accepts it.
        ...{ selectComponentClass: PageSizeSelect },
    };
};

export default getProductsTablePagination;
